import type { BranchMinimumCartSystemValueType } from '../enums/BranchMinimumCartSystemValueType'

export class BranchMinimumCartSystemFilterEntity {
  name?: string
  isDefault?: boolean
  valueType?: BranchMinimumCartSystemValueType
  page?: number
  limit?: number
}
